import { useEffect } from "react";

const useInitWithScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export default useInitWithScrollToTop;
